import type { RouteLocation } from 'vue-router'

export default [
  {
    path: '/charger/:connectorId/:chargerId',
    redirect: (to: RouteLocation) =>
      `/charging/${to.params.connectorId}/${to.params.chargerId}`
  },
  {
    path: '/charger/:connectorId/:chargerId/detail',
    redirect: (to: RouteLocation) =>
      `/charging/${to.params.connectorId}/${to.params.chargerId}`
  },
  {
    path: '/charger/:connectorId/:chargerId/rate',
    redirect: (to: RouteLocation) =>
      `/charging/${to.params.connectorId}/${to.params.chargerId}`
  },
  {
    path: '/charger/:connectorId/:chargerId/checkout',
    redirect: (to: RouteLocation) =>
      `/charging/${to.params.connectorId}/${to.params.chargerId}`
  }
]
